import { render, staticRenderFns } from "./ovrz8.vue?vue&type=template&id=2621dcf9"
import script from "./ovrz8.vue?vue&type=script&lang=js"
export * from "./ovrz8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports